import React, { useState, useEffect } from "react";
import { withRouter } from "react-router";
import {setUnsurEdit} from "../actions"
import { doGet, doPost,doPut } from "../services/api-service";
import { useSelector,useDispatch } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Typography from "@material-ui/core/Typography";
import Select from "react-select";
import Checkbox from '@material-ui/core/Checkbox';
import DebouncedTextField from "../components/DebouncedTextField";



const PaUnsurCreateComponent = props => {
    const dispatch = useDispatch()
    const user = useSelector(state => state.user.user)
    const unsur_to_edit = useSelector(state => state.assessment.unsur_to_edit)
    const [status, setStatus] = useState(true);
    const [external, setexternal] = useState(false);
    const [externalOptions, setexternalOptions] = useState([]);
    const [externalSource, setexternalSource] = useState(null);
    const [optional, setoptional] = useState(false);
    const [bobotUnsurReceiver, setbobotUnsurReceiver] = useState(null);
    const [siblingUnsurOptions, setsiblingUnsurOptions] = useState([]);
    const [code, setCode] = useState("");
    const [name, setName] = useState("");
    const [aspek, setAspek] = useState(null);
    const [subAspek, setSubAspek] = useState(null);
    const [aspekOption, setAspekOption] = useState([]);
    const [subAspekOption, setSubAspekOption] = useState([]);
    const [unsur, setunsur] = useState(null);
    const [category_0_label, setcategory_0_label] = useState("");
    const [category_1_label, setcategory_1_label] = useState("");
    const [category_2_label, setcategory_2_label] = useState("");
    const [category_3_label, setcategory_3_label] = useState("");
    const [category_4_label, setcategory_4_label] = useState("");
    
    const { classes } = props;

    useEffect(() => {        
        getAspekOption();
        getExternalData()
    }, []);

    useEffect(() => {
        if(unsur_to_edit){
            getUnsurDetail(unsur_to_edit)
        }
    }, [unsur_to_edit])

    useEffect(() => {        
        if(externalOptions.length>0 && unsur){
            setexternalSource(externalOptions.filter(ex=>ex.value===unsur.external)[0])
        }
    }, [externalOptions, unsur]);

    useEffect(() => {        
        if(siblingUnsurOptions.length>0 && unsur){
            setbobotUnsurReceiver(siblingUnsurOptions.filter(u=>u.value===unsur.receiver_unsur_code)[0])
        }
    }, [siblingUnsurOptions, unsur]);

    const getExternalData = async (unsur) => {
        
        const initial= [
            {
                label: "HRIS Ijin",
                value:"hris_ijin"
            },
            {
                label: "HRIS Absen",
                value:"hris_absen"
            }
        ]

        let externalDatas = [...externalOptions, ...initial]

        const dataExternalGroup = await getExternalDataGroup()

        const dataSurvey = await getDataSurvey()
        
        if(dataExternalGroup){
            externalDatas = [...externalDatas, ...dataExternalGroup]
        }
        if(dataSurvey){
            externalDatas = [...externalDatas, ...dataSurvey]
        }

        setexternalOptions(externalDatas)
    }
    
    const getUnsurDetail = async (unsur) => {
        const params = {};
        const response = await doGet("pa/unsur/"+unsur.id, params);
        if(response && response.data){
            const unsur = response.data
            setCode(unsur.code)
            setName(unsur.name)
            let aspek = {
                label:unsur.aspek_code+" - "+unsur.aspek_name, 
                value:unsur.aspek_id
            }
            let subAspek = {
                label:unsur.sub_aspek_code+" - "+unsur.sub_aspek_name, 
                value:unsur.sub_aspek_id
            }
            setAspek(aspek)
            setSubAspek(subAspek)
            setexternal(unsur.external?true:false)            
            setoptional(unsur.optional===1)
            getUnsurSiblings(unsur.sub_aspek_id)
            setunsur(unsur)
            setcategory_0_label(unsur.category_0_label)
            setcategory_1_label(unsur.category_1_label)
            setcategory_2_label(unsur.category_2_label)
            setcategory_3_label(unsur.category_3_label)
            setcategory_4_label(unsur.category_4_label)
            
        }
            
    }

    const getExternalDataGroup = async () =>{
        const params={}
        const response = await doGet("pa/external/group/current",params)
        if(response&&response.data&&response.data.length>0){
            return response.data.map(group=>({value:group, label:group}))            
        }
    }

    const getDataSurvey = async() => {
        const params={}
        const response = await doGet("survey/select/current",params)
        if(response&&response.data&&response.data.length>0){
            return response.data.map(survey=>({value:"survey-"+survey.id, label:survey.judul}))            
        }
    }
    
    const getAspekOption = async () => {
        const params={is_active:1};
        const response = await doGet("pa/aspek", params);
        if (response&&response.data&&response.data.length > 0) {
            const dataForSelect = response.data.map(aspek => ({
                value: aspek.id,
                label: `${aspek.code} - ${aspek.name}`
            }));
            setAspekOption(dataForSelect);
        }
    };

    const getSubAspekOption = async aspek_id => {
        const params = { aspek_id: aspek_id };
        const response = await doGet("pa/subaspek", params);
        if (response&&response.data&&response.data.length > 0) {
            const dataForSelect = response.data.map(subaspek => ({
                value: subaspek.id,
                label: `${subaspek.code} - ${subaspek.name}`
            }));
            setSubAspekOption(dataForSelect);
        }
    };

    const getUnsurSiblings = async subAspekId => {
        const params = { subaspek: subAspekId, select:1 };
        const response = await doGet("pa/unsur/subaspek", params);
        if (response&&response.data&&response.data.length > 0) {
            const dataForSelect = response.data.map(unsur => ({
                value: unsur.code,
                label: `${unsur.code} - ${unsur.name}`
            }));
            setsiblingUnsurOptions(dataForSelect);
        }
    };


    const submit = async() => {
        if(!unsur_to_edit){
            create();
        }else{
            await edit()
            dispatch(setUnsurEdit())
        }
        props.history.goBack();
    };

    const edit =async ()=>{
        const params = {
            id:unsur_to_edit.id,
            code: code,
            name: name,
            is_optional: optional?1:0,
            receiver_unsur_code: bobotUnsurReceiver?bobotUnsurReceiver.value:null,
            external_data:externalSource?externalSource.value:null,
            status: status == true ? 1 : 0,
            updated_by: user.emp_id,
            category_0_label:category_0_label,
            category_1_label:category_1_label,
            category_2_label:category_2_label,
            category_3_label:category_3_label,
            category_4_label:category_4_label,
            
        };
        await doPut("pa/unsur", params, "save unsur");
    }

    const create = async () => {
        if (aspek !== null) {
            const params = {
                sub_aspek_id: subAspek.value,
                code: code,
                name: name,
                is_optional: optional?1:0,
                receiver_unsur_code: bobotUnsurReceiver?bobotUnsurReceiver.value:null,
                external_data:externalSource?externalSource.value:null,
                status: status == true ? 1 : 0,
                creator: user.emp_id,
                category_0_label:category_0_label,
                category_1_label:category_1_label,
                category_2_label:category_2_label,
                category_3_label:category_3_label,
                category_4_label:category_4_label
            };
            await doPost("pa/unsur", params, "save sub aspek");

        }
    };

    const cancel = () => {
        props.history.goBack();
    };
    const statusChange = e => {
        setStatus(!status);
    };
    const codeChange = e => {
        setCode(e.target.value);
    };
    const nameChange = e => {
        setName(e.target.value);
    };

    const externalChange = e => {
        setexternal(e.target.checked);
        if(!e.target.checked)
        setexternalSource(null)
    };

    const optionalChange = e => {
        setoptional(e.target.checked);
        if(!e.target.checked)
        setbobotUnsurReceiver(null)
    };    

    const aspekChange = e => {
        setAspek(e);
        setSubAspek(null);
        getSubAspekOption(e.value);
    };

    const subAspekChange = e => {
        setSubAspek(e);
        getUnsurSiblings(e.value)
    };

    const externalSourceChange = e => {
        setexternalSource(e);
    };

    const bobotUnsurReceiverChange = e => {
        setbobotUnsurReceiver(e);
    };


    const categoryLabelChange = (value,score) => {
        
        switch(score){
            case 0:
                setcategory_0_label(value)
            break;
            case 1:                
                setcategory_1_label(value)
            break;
            case 2:
                setcategory_2_label(value)
            break;
            case 3:
                setcategory_3_label(value)
            break;
            case 4:
                setcategory_4_label(value)
            break;
        }        
    }



    const title = unsur_to_edit ? "Edit Unsur" : "Create New Unsur"
    return (
        <Grid container direction="column">
            <Grid item xs={6} container>
                <Grid item xs={12}>
                    <Typography
                        variant="h6"
                        gutterBottom
                        className="animated slideInLeft"
                    >
                        {title}
                    </Typography>
                </Grid>

                <Grid container>
                    <Grid item xs={12}>
                        <Select
                            isClearable={true}
                            value={aspek}
                            options={aspekOption}
                            onChange={aspekChange}
                            placeholder="Select Aspek"
                            styles={selectCustomZindex}
                        />
                    </Grid>
                </Grid>

                <Grid container className={classes.marginTops}>
                    <Grid item xs={12}>
                        <Select
                            isClearable={true}
                            value={subAspek}
                            options={subAspekOption}
                            onChange={subAspekChange}
                            placeholder="Select Sub Aspek"
                            styles={selectCustomZindex}
                        />
                    </Grid>
                </Grid>

                <Grid container>
                    <TextField
                        id="Code"
                        label="Code"
                        value={code}
                        margin="dense"
                        variant="outlined"
                        fullWidth
                        onChange={codeChange}
                    />
                </Grid>
                <Grid container>
                    <TextField
                        id="Name"
                        label="Name"
                        value={name}
                        margin="dense"
                        variant="outlined"
                        fullWidth
                        onChange={nameChange}
                        multiline
                        rows={6}
                    />
                </Grid>

                <Grid container alignContent="center">
                    <FormControlLabel
                        control={
                        <Checkbox
                            checked={external}
                            onChange={externalChange}
                            name="external"
                            color="primary"
                        />
                        }
                        label="External"
                    />
                    {
                        external &&
                        <Select                            
                            value={externalSource}
                            options={externalOptions}
                            onChange={externalSourceChange}
                            placeholder="Select External Data"
                            styles={selectCustomZindex}
                        />
                    }                    
                
                </Grid>

                <Grid container>
                    <FormControlLabel
                        control={
                        <Checkbox
                            checked={optional}
                            onChange={optionalChange}
                            name="optional"
                            color="primary"
                        />
                        }
                        label="Optional"
                    />
                    {
                        optional &&
                        <Select                            
                            value={bobotUnsurReceiver}
                            options={siblingUnsurOptions}
                            onChange={bobotUnsurReceiverChange}
                            placeholder="Select bobot receiver"
                            styles={selectCustomZindex}
                        />
                    }
                </Grid>
                
                <Grid container>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={status}
                                onChange={statusChange}
                                color="primary"
                                inputProps={{
                                    "aria-label": "primary checkbox"
                                }}
                            />
                        }
                        label={status ? "active" : "inactive"}
                    />
                </Grid>

            </Grid>

            <Grid container className={classes.category_container}>
                <Grid item xs={12} container spacing={8} className={classes.category_row}>   
                                                       
                    <Grid item className={classes.category_field}>
                        <DebouncedTextField
                                id="score4"
                                label="scored 4 means"
                                value={category_4_label}
                                key_id_1={4}
                                margin="dense"
                                placeholder="meaning if the score is 4"
                                variant="outlined"
                                fullWidth
                                onChange={categoryLabelChange}
                                style={{backgroundColor:"white", borderRadius:4}}
                            />
                    </Grid>
                    <Grid item className={classes.category_field}>
                        <DebouncedTextField
                            id="score3"
                            label="scored 3 means"
                            value={category_3_label}
                            key_id_1={3}
                            placeholder="meaning if the score is 3"
                            margin="dense"
                            variant="outlined"
                            fullWidth
                            onChange={categoryLabelChange}
                            style={{backgroundColor:"white", borderRadius:4}}
                        />
                    </Grid>
                    <Grid item className={classes.category_field}>
                        <DebouncedTextField
                            id="score2"
                            label="scored 2 means"
                            value={category_2_label}
                            key_id_1={2}
                            placeholder="meaning if the score is 2"
                            margin="dense"
                            variant="outlined"
                            fullWidth
                            onChange={categoryLabelChange}
                            style={{backgroundColor:"white", borderRadius:4}}
                        />
                    </Grid>
                    <Grid item className={classes.category_field}>
                        <DebouncedTextField
                            id="score1"
                            label="scored 1 means"
                            value={category_1_label}
                            key_id_1={1}
                            placeholder="meaning if the score is 1"
                            margin="dense"
                            variant="outlined"
                            fullWidth
                            onChange={categoryLabelChange}
                            style={{backgroundColor:"white", borderRadius:4}}
                        />
                    </Grid>
                    <Grid item className={classes.category_field}>
                        <DebouncedTextField
                                id="score0"
                                label="scored 0 means"
                                value={category_0_label}
                                key_id_1={0}
                                margin="dense"
                                placeholder="meaning if the score is 0"
                                variant="outlined"
                                fullWidth
                                onChange={categoryLabelChange}
                                style={{backgroundColor:"white", borderRadius:4}}
                            />
                    </Grid>  

                </Grid>
            </Grid>


            <Grid
                    justify="flex-end"
                    container
                    className={classes.marginTops}
                    spacing={8}
                >
                    <Grid item>
                        <Button variant="outlined" onClick={cancel}>
                            cancel
                        </Button>
                    </Grid>

                    <Grid item>
                        <Button
                            onClick={submit}
                            color="primary"
                            variant="contained"
                        >
                            Save
                        </Button>
                    </Grid>
                </Grid>
        </Grid>
    );
};

const styles = theme => ({
    marginTops: {
        marginTop: 15
    },
    container: {
        marginTop: -16,
        marginLeft: 5
    },
    marginOver: {
        marginTop: -25
    },
    score: {
        maxWidth: 50
    },
    category_container:{
        
    },
    category_row:{
        paddingRight:5,
        backgroundColor:"#c9bfff",
        borderRadius:4
    },
    category_field:{
        flex:10
    },
});

export default withRouter(withStyles(styles)(PaUnsurCreateComponent));

export const selectCustomZindex = {
    control: (base, state) => ({
        ...base,
        minWidth: "150px",
        margin: "0 4px"
    }),
    container: (base, state) => {
        return {
            ...base,
            flex: 1,
            zIndex: state.isFocused ? "1100" : "1" //Only when current state focused
        };
    }
};
